import React, { FC, useCallback } from 'react';
import { ArgsSelect, ArgsCheckbox, ArgsInput } from './BasicComponents';
import { OperatorProps } from '../../../../@types/TemplateOperators';

enum OperationModes {
  DEFAULT = 'Default',
  ADVANCED = 'Advanced'
}

enum ArgsIndexes {
  MODE = 0,
  ALPA = 1,
  NUMERIC = 2,
  WHITESPACE = 3,
  SPESIAL = 4,
  SEARCH = 5,
  REPLACE = 6,
  OCCURRENCE = 7
}

const operationMode = [
  { label: 'Default', value: 'Default' },
  { label: 'Advanced', value: 'Advanced' }
];

const occurrenceOptions = [
  { label: 'All', value: 'All' },
  { label: 'First', value: 'First' },
  { label: 'Last', value: 'Last' }
];

const Replace: FC<OperatorProps> = ({ step, handleArgsChange }) => {
  const [
    mode = null,
    alpha = null,
    numeric = null,
    whitespace = null,
    special = null,
    search = null,
    replace = null,
    occurrence = null
  ] = step.args;

  const argsChangeHandler = useCallback(
    (name) =>
      (value: any): void => {
        const initialValue = [mode, alpha, numeric, whitespace, special, search, replace, occurrence];
        initialValue[name] = value;
        handleArgsChange(initialValue);
      },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleArgsChange]
  );

  const defaultModeFields = (
    <>
      <div className="flex items-baseline mt-6 w-full" data-testid="default-mode-fields-block">
        <ArgsCheckbox
          name="alpha"
          label="alpha"
          subLabel="Replace A-Z"
          checked={alpha}
          value="alpha"
          onChange={argsChangeHandler(ArgsIndexes.ALPA)}
        />
      </div>
      <div className="flex items-baseline mt-6 w-full">
        <ArgsCheckbox
          name="numeric"
          label="numeric"
          subLabel="Replace 0-9"
          checked={numeric}
          value="numeric"
          onChange={argsChangeHandler(ArgsIndexes.NUMERIC)}
        />
      </div>
      <div className="flex items-baseline mt-6 w-full">
        <ArgsCheckbox
          name="whitespace"
          label="whitespace"
          subLabel="Replace spaces and tabs"
          checked={whitespace}
          value="whitespace"
          onChange={argsChangeHandler(ArgsIndexes.WHITESPACE)}
        />
      </div>
      <div className="flex items-baseline mt-6 w-full">
        <ArgsCheckbox
          name="special"
          label="special"
          subLabel="Replace !@#$%^&*()[].,"
          checked={special}
          value="special"
          onChange={argsChangeHandler(ArgsIndexes.SPESIAL)}
        />
      </div>
    </>
  );

  const advancedModeFields = (
    <div className="flex mt-6 w-full" data-testid="advanced-mode-fields-block">
      <ArgsInput
        initialValue={search || ''}
        onChange={argsChangeHandler(ArgsIndexes.SEARCH)}
        label="search"
        subLabel="Characters to search for replacing"
      />
    </div>
  );

  const modeDependentFields = mode === OperationModes.DEFAULT ? defaultModeFields : advancedModeFields;

  return (
    <div data-testid="replace-operator">
      <div className="flex mt-2 w-full">
        <ArgsSelect
          argsSelectLabel="mode"
          options={operationMode}
          onChange={argsChangeHandler(ArgsIndexes.MODE)}
          value={mode || ''}
          label="Operation Mode"
        />
      </div>
      {mode && modeDependentFields}
      <div className="flex mt-6 w-full">
        <ArgsInput
          initialValue={replace || ''}
          onChange={argsChangeHandler(ArgsIndexes.REPLACE)}
          label="replace"
          subLabel="Characters to replace with"
        />
      </div>
      <div className="flex mt-2 w-full">
        <ArgsSelect
          argsSelectLabel="occurrence"
          options={occurrenceOptions}
          onChange={argsChangeHandler(ArgsIndexes.OCCURRENCE)}
          value={occurrence || ''}
          label="Which occurrence of search characters should be replaced"
          maxVisible={2}
        />
      </div>
    </div>
  );
};

export default Replace;
